<script setup lang="ts">
import ResourceList from '@shell/components/ResourceList/index.vue';
</script>

<template>
  <ResourceList />
</template>

